import React, { Component } from 'react'
import '../Configuration.css';
import { Button, Box, Stack, IconButton, Tooltip } from '@mui/material'
import { withTranslation } from 'react-i18next'
import { DataGrid } from '@mui/x-data-grid';
import CommonGridHeader, { DeletePopup } from '../../../Components/Common Components/CommonComponents';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';

class DisSumTemplateConfig extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disSumTemData: [],
      page: 0,
      pageSize: 10,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      deletedID: null,
      deletePopup: false,
      disableBtn: false,
    }
  }

  componentDidMount() {
    this.getDisSumDetails()
  }
  componentDidUpdate(prevProps) {
    if (prevProps.history?.location?.state?.deleteID !== this.state.deletedID && prevProps.history?.location?.state?.deleteID !== null && prevProps.history?.location?.state?.deleteID !== undefined) {
      this.setState({
        deletedID: prevProps.history?.location?.state?.deleteID
      }, () => {
        this.props.history.push({ state: { deleteID: null } })
        this.deleteDisSumDetails()
      })
    }
  }

  LoaderFunction = (key) => {
    this.setState({
        isLoader: key
    })
}

  getDisSumDetails = () => {
    try {
      this.LoaderFunction(true)
      RestAPIService.getAll(Serviceurls.IP_TEMPLATE_DIS_SUM)
        .then(response => {
          if (response.data.status === 'success') {
            this.setState({
              disSumTemData: response.data ? response.data.data : []
            },()=>{this.LoaderFunction(false)})
          }
        }).catch(e => {
          this.LoaderFunction(false)
          if (e.response?.data?.status === "fail") {
            this.errorMessage(e.response.data.message)
          } else {
            this.errorMessage(e.message)
          }
        })

    } catch (e) {
      this.LoaderFunction(false)
      this.errorMessage(e.message)
    }
  }
  deleteDisSumDetails = () => {
    try {
      var states = this.state
      let item = this.state.rowData ? this.state.rowData : {}
      var selectId = item.id ? item.id : "";
      let deletedID = states.disSumTemData.map((item) => states?.deletedID === item.id ? item.id : "")
      var ID = selectId ? selectId : deletedID
      this.setState({disableBtn: true})
      RestAPIService.delete(Serviceurls.IP_TEMPLATE_DIS_SUM + '?template_id=' + ID)
        .then(response => {
          if (response.data.status === 'success') {
            this.successMessage(response?.data?.message)
            this.getDisSumDetails()
            this.setState({disableBtn: false, deletePopup : false})
          }
        }).catch(e => {
          if (e.response?.data?.status === "fail") {
            this.errorMessage(e.response.data.message)
          } else {
            this.errorMessage(e.message)
          }
          this.setState({disableBtn: false, deletePopup : false})
        })

    } catch (e) {
      this.errorMessage(e.message)
      this.setState({disableBtn: false, deletePopup: false})
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }
  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  popupClose = () => {
    this.setState({ deletePopup: false })
  }

  renderDisSumTbl = () => {
    const { t } = this.props
    var states = this.state
    const columns = [
      {
        field: 'template_name', headerName: t('TemplateName'), flex: 0.22, headerClassName: 'eMed_Dis_Tem_TblHead',
        renderCell: (params) => (
          <div>
            {params?.row?.template_name ? params.row.template_name : '-'}
          </div>
        )
      },
      {
        field: 'layout_names', headerName: t('UsedLayout'), flex: 0.22, headerClassName: 'eMed_Dis_Tem_TblHead',
        renderCell: (params) => (
          <div>
            {params?.row?.layout_names ? params.row.layout_names : '-'}
          </div>
        )
      },
      {
        field: 'created_by', headerName: t('CreatedBy&Date'), flex: 0.23, headerClassName: 'eMed_Dis_Tem_TblHead',
        renderCell: (params) => (
          <div>
            {params?.row?.created_by && params?.row?.created_date ? params.row.created_by + ' On ' + params.row.created_date : '-'}
          </div>
        )
      },
      {
        field: 'modified_by', headerName: t('LastModifiedBy&Date'), flex: 0.23, headerClassName: 'eMed_Dis_Tem_TblHead',
        renderCell: (params) => (
          <div>
            {params?.row?.modified_by && params?.row?.modified_date ? params.row.modified_by + ' On ' + params.row.modified_date : '-'}
          </div>
        )
      },
      {
        field: 'action', headerName: t('Action'), flex: 0.10, headerClassName: 'eMed_Dis_Tem_TblHead', headerAlign: 'center', align: 'center',
        renderCell: (params) => (
          <Tooltip title={'Delete'} placement='top' arrow>
            <IconButton  disabled={!CheckAccessFunc("front_office", "Settings", "Template Configuration",  "Discharge Summary Template Configuration", "SubTab")?.editAccess || this.state.deletePopup} className='eMed_Dis_Sum_Tem_BtnGroup' onClick={() => { this.setState({deletePopup: true, rowData: params}) }}>
              <img className='eMed_DisSum_Lay_TblDel' src={CheckAccessFunc("front_office", "Settings", "Template Configuration",  "Discharge Summary Template Configuration", "SubTab")?.editAccess ? ImagePaths.Delete.default : ImagePaths.DisabledDelete.default} alt='Delete' />
            </IconButton>
          </Tooltip>
        )
      },
    ]
    return (
      <Box className='eMed_Dis_Tem_Tbl'>
        <DataGrid
          rows={this.state.disSumTemData}
          columns={columns}
          getRowId={(row) => row['id']}
          pageSize={this.state.pageSize}
          page={this.state.page}
          rowsPerPageOptions={[10, 20, 30]}
          components={{
            Toolbar: CommonGridHeader.CommonToolBar,
            NoRowsOverlay: () => (
              <Stack className='eMed_conf_nodata'>
                {t("NoRecordsFound")}
              </Stack>
            )
          }}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          density={'Standard'}
          onCellClick={(params) => params.field === 'action' ? null : this.routeToLayout(params)}
          pagination
          onPageChange={(newPage) => { this.setState({ page: newPage }) }}
          onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }) }}
          getRowClassName={(params) => params.row.appointment_status === "Cancelled" ? 'eMed_OP_CancelPatient' : null}
          loading={this.state.isLoader}
        />
      </Box>
    )
  }

  routeToLayout = (params) => {
    var states = this.state
    var selectId = params.row.id;
    this.props.history.push({ pathname: '/Settings/TemplateConfig/DisSumTemplateConfig/Add', state: { selectedID: selectId } })
  }
  msgClose(){
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  render() {
    const { t } = this.props
    return (
      <Box Component='div' className='eMed_usrconf_container'>
        <Box className='eMed_usrconf_header'>
          <Button disabled={!CheckAccessFunc("front_office", "Settings", "Template Configuration",  "Discharge Summary Template Configuration", "SubTab")?.editAccess} variant='contained' onClick={() => { this.props.history.push('/Settings/TemplateConfig/DisSumTemplateConfig/Add') }}>{t('AddNewTemplate')}</Button>
        </Box>
        <Box>
          {this.renderDisSumTbl()}
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.deletePopup ? 
          <DeletePopup
            DeletTitle={`Are you sure you want to delete  ${this.state.rowData?.row?.template_name ? this.state.rowData?.row?.template_name : "-"} temp ?`}
            deleteAlertPopupClose={this.popupClose.bind(this)}
            removeData={this.deleteDisSumDetails.bind(this)}
            DeleteNotify={"It will affect the entire configuration and Saved Datas"}
            disable={this.state.disableBtn}
          /> 
        : null}
      </Box>
    )
  }
}
export default withTranslation()(DisSumTemplateConfig);